import { Routes } from '@angular/router';
import { environment } from 'environments/environment';

import { CanActivateAuthGuard } from './common/can-activate-auth.guard';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { OrgLayoutComponent } from './layouts/org/org-layout.component';

export const AppRoutes: Routes = [
    {
        path: '',
        component: AdminLayoutComponent,
        canActivateChild: [CanActivateAuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'admin',
                loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'admin',
                loadChildren: () => import('./signup-form/signup-form.module').then(m => m.SignupFormModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'analytics',
                loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'students',
                loadChildren: () => import('./students/students.module').then(m => m.StudentsModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: environment.localization.enquiriesUrl,
                loadChildren: () => import('./enquiries/enquiries.module').then(m => m.EnquiriesModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'communications',
                loadChildren: () => import('./communications/communications.module').then(m => m.CommunicationsModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'applications',
                loadChildren: () => import('./applications/applications.module').then(m => m.ApplicationsModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'events',
                loadChildren: () => import('./events/events.module').then(m => m.EventsModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'components',
                loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'user-page',
                loadChildren: () => import('./userpage/user.module').then(m => m.UserModule),
                canActivateChild: [CanActivateAuthGuard],
            },
            {
                path: 'system-admin',
                loadChildren: () => import('./system-admin/system-admin.module').then(m => m.SystemAdminModule),
                canActivateChild: [CanActivateAuthGuard],
            },
        ],
    },
    {
        path: '',
        component: OrgLayoutComponent,
        canActivateChild: [CanActivateAuthGuard],
        children: [
            {
                path: 'orgs',
                loadChildren: () => import('./org/org.module').then(m => m.OrgModule),
                canActivateChild: [CanActivateAuthGuard],
            },
        ],
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            {
                path: 'noAuth',
                loadChildren: () => import('./noAuth/noAuth.module').then(m => m.NoAuthModule),
            },
            {
                path: 'webforms',
                loadChildren: () => import('./webforms/webforms.module').then(m => m.WebformsModule),
            },
            {
                path: 'representative',
                loadChildren: () => import('./events/events.module').then(m => m.EventsModule),
            },
            {
                path: '',
                loadChildren: () => import('./applications/forms.module').then(m => m.EtFormsModule),
            },
        ],
    },
];
